function initFeather(scope) {
  if (window.feather) feather.replace();
}

function initHeroSliders(scope) {
  scope.querySelectorAll('[data-hero-slider]').forEach(function (el) {
    if (el.swiper) return;
    new Swiper(el, {
      loop: true,
      autoplay: { delay: 5000 },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    var activeHeading = el.querySelector('.swiper-slide-active .hero-slide__heading');
    animateHeroHeading(activeHeading);
  });
}

function initBestSellingSwipers(scope) {
  scope.querySelectorAll('[data-best-selling-swiper]').forEach(function (el) {
    if (el.swiper) return;
    var desktopCount = parseFloat(el.getAttribute('data-desktop-count')) || 4;
    var swiper = new Swiper(el, {
      loop: true,
      centeredSlides: true,
      grabCursor: true,
      autoplay: { delay: 8000, disableOnInteraction: false },
      breakpoints: {
        0: { slidesPerView: 1.9, spaceBetween: 16 },
        769: { slidesPerView: desktopCount + 0.9, spaceBetween: 24 },
      },
    });

    var wrap = el.closest('.best-selling-swiper-wrap');
    if (wrap) {
      var prevBtn = wrap.querySelector('[data-swiper-prev]');
      var nextBtn = wrap.querySelector('[data-swiper-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { swiper.slidePrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { swiper.slideNext(); });
    }
  });
}

function initMobileMenu(scope) {
  var menuToggle = scope.querySelector('[data-menu-toggle]');
  var menu = scope.querySelector('[data-mobile-menu]');
  if (menuToggle && menu && !menuToggle.dataset.bound) {
    menuToggle.dataset.bound = 'true';
    menuToggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
    });
  }
}

function initJournalViewToggle(scope) {
  scope.querySelectorAll('[data-journal-view-toggle]').forEach(function (toggle) {
    if (toggle.dataset.bound) return;
    toggle.dataset.bound = 'true';

    var list = toggle.parentElement.querySelector('[data-journal-list]');
    if (!list) return;

    var STORAGE_KEY = 'bkj_journal_view';
    var buttons = toggle.querySelectorAll('[data-view-btn]');

    function setView(view) {
      list.className = 'journal-list__items journal-list__items--' + view;
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-view-btn') === view);
      });
      if (window.feather) feather.replace();
    }

    var savedView = null;
    try { savedView = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    setView(savedView || list.getAttribute('data-default-view') || 'window');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-view-btn');
        setView(view);
        try { localStorage.setItem(STORAGE_KEY, view); } catch (e) {}
      });
    });
  });
}

function initCartPage(scope) {
  var checkbox = scope.querySelector('[data-agree-checkbox]');
  var checkoutBtn = scope.querySelector('[data-checkout-btn]');
  if (checkbox && checkoutBtn && !checkbox.dataset.bound) {
    checkbox.dataset.bound = 'true';
    checkbox.addEventListener('change', function () {
      checkoutBtn.disabled = !checkbox.checked;
    });
  }

  var discountInput = scope.querySelector('[data-discount-input]');
  var discountApplyBtn = scope.querySelector('[data-discount-apply]');
  var discountAppliedEl = scope.querySelector('[data-discount-applied]');
  if (discountInput && discountApplyBtn && !discountApplyBtn.dataset.bound) {
    discountApplyBtn.dataset.bound = 'true';
    discountApplyBtn.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) return;
      discountInput.dataset.appliedCode = code;
      if (discountAppliedEl) {
        discountAppliedEl.textContent = 'Will apply "' + code + '" at checkout';
        discountAppliedEl.style.display = 'block';
      }
    });
  }

  // Discount codes can't be validated on the cart page itself; carry
  // whatever code was entered through to checkout as a ?discount= param,
  // which Shopify auto-applies once checkout loads.
  if (checkoutBtn && discountInput && !checkoutBtn.dataset.discountBound) {
    checkoutBtn.dataset.discountBound = 'true';
    checkoutBtn.addEventListener('click', function (e) {
      var code = discountInput.dataset.appliedCode || discountInput.value.trim();
      if (code) {
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      }
    });
  }

  scope.querySelectorAll('[data-qty-input]').forEach(function (input) {
    if (input.dataset.bound) return;
    input.dataset.bound = 'true';
    var decreaseBtn = input.parentElement.querySelector('[data-qty-decrease]');
    var increaseBtn = input.parentElement.querySelector('[data-qty-increase]');
    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var val = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = val;
        input.closest('form').submit();
      });
    }
    if (increaseBtn) {
      increaseBtn.addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
        input.closest('form').submit();
      });
    }
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });
}

function initCustomerLoginToggle(scope) {
  var toggles = scope.querySelectorAll('[data-toggle-recover]');
  var recoverForm = scope.querySelector('[data-recover-form]');
  if (!toggles.length || !recoverForm || recoverForm.dataset.bound) return;
  recoverForm.dataset.bound = 'true';
  var loginFormEl = scope.querySelector('.customer-login .customer-form--login');
  var loginForm = loginFormEl ? loginFormEl.closest('form') : null;
  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      recoverForm.hidden = !recoverForm.hidden;
      if (loginForm) loginForm.hidden = !recoverForm.hidden;
    });
  });
}

function initCustomerAddressToggles(scope) {
  var newToggle = scope.querySelectorAll('[data-toggle-new-address]');
  var newForm = scope.querySelector('[data-new-address-form]');
  if (newToggle.length && newForm && !newForm.dataset.bound) {
    newForm.dataset.bound = 'true';
    newToggle.forEach(function (btn) {
      btn.addEventListener('click', function () {
        newForm.hidden = !newForm.hidden;
      });
    });
  }

  scope.querySelectorAll('[data-toggle-edit]').forEach(function (btn) {
    if (btn.dataset.bound) return;
    btn.dataset.bound = 'true';
    var id = btn.getAttribute('data-toggle-edit');
    btn.addEventListener('click', function () {
      var editForm = scope.querySelector('[data-address-edit="' + id + '"]');
      if (editForm) editForm.hidden = !editForm.hidden;
    });
  });
}

function initAll(scope) {
  scope = scope || document;
  initFeather(scope);
  initHeroSliders(scope);
  initJournalViewToggle(scope);
  initBestSellingSwipers(scope);
  initMobileMenu(scope);
  initCartPage(scope);
  initCustomerLoginToggle(scope);
  initCustomerAddressToggles(scope);
  initScrollAnimations(scope);
}

document.addEventListener('DOMContentLoaded', function () {
  initAll(document);

  window.addEventListener('load', function () {
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });
  }
  document.querySelectorAll('img').forEach(function (img) {
    if (!img.complete) {
      img.addEventListener('load', function () {
        if (window.ScrollTrigger) ScrollTrigger.refresh();
      });
    }
  });
});

// Shopify Theme Editor swaps a section's HTML via AJAX whenever its
// settings change, without re-running page-load scripts. Re-init
// everything scoped to just the reloaded section so carousels/animations
// keep working while editing in the customizer.
document.addEventListener('shopify:section:load', function (event) {
  initAll(event.target);
  if (window.ScrollTrigger) {
    setTimeout(function () { ScrollTrigger.refresh(); }, 50);
  }
});

document.addEventListener('shopify:section:unload', function (event) {
  event.target.querySelectorAll('.swiper').forEach(function (el) {
    if (el.swiper) el.swiper.destroy(true, true);
  });
});

function animateHeroHeading(headingEl) {
  if (!headingEl || !window.SplitType || !window.gsap) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var split = new SplitType(headingEl, { types: 'words,chars' });
  gsap.from(split.chars, {
    opacity: 0,
    y: 40,
    duration: 1,
    stagger: 0.04,
    ease: 'power3.out',
    delay: 0.2,
  });
}

function initScrollAnimations(scope) {
  if (!window.gsap || !window.ScrollTrigger) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  gsap.registerPlugin(ScrollTrigger);

  scope.querySelectorAll('.gsap-reveal').forEach(function (el) {
    if (el.dataset.revealBound) return;
    el.dataset.revealBound = 'true';
    gsap.set(el, { opacity: 0, y: 90 });
    ScrollTrigger.create({
      trigger: el,
      start: 'top 88%',
      onEnter: function () {
        gsap.to(el, { opacity: 1, y: 0, duration: 1.8, ease: 'power3.out', overwrite: true });
      },
      onLeaveBack: function () {
        gsap.to(el, { opacity: 0, y: 90, duration: 0.6, ease: 'power2.in', overwrite: true });
      },
    });
  });

  scope.querySelectorAll('.gsap-parallax').forEach(function (el) {
    if (el.dataset.parallaxBound) return;
    el.dataset.parallaxBound = 'true';
    var container = el.closest('section') || el.parentElement;
    gsap.set(el, { scale: 1.15 });
    gsap.to(el, {
      yPercent: 12,
      ease: 'none',
      scrollTrigger: {
        trigger: container,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  });
}
